module.exports = __webpack_public_path__ + "static/media/RetrieveAwardsLogo.c4ad46cc.png";